import React, { useMemo, useContext } from 'react';
import { useQuery, UseQueryResult } from 'react-query';

import { deeplinksApi } from 'api';
import { QueryKey } from 'enums';
import { Deeplink, TradeMethod } from 'types';

const DeeplinksContext = React.createContext<{
  tradeMethod?: TradeMethod;
  deeplinksQuery: UseQueryResult<Deeplink[]>;
} | null>(null);

export const DeeplinksProvider = ({
  children,
  tradeMethod,
}: {
  children: React.ReactNode;
  tradeMethod?: TradeMethod;
}) => {
  const fetchDeeplinks = useMemo(
    () => deeplinksApi.getAllByTradeMethodId(tradeMethod!.id),
    [tradeMethod],
  );

  const deeplinksQuery = useQuery(
    [QueryKey.Deeplinks, tradeMethod?.id],
    () => fetchDeeplinks(),
    { enabled: !!tradeMethod },
  );

  return (
    <DeeplinksContext.Provider
      value={{
        tradeMethod,
        deeplinksQuery,
      }}
    >
      {children}
    </DeeplinksContext.Provider>
  );
};

export const useDeeplinks = () => {
  const context = useContext(DeeplinksContext);
  if (context === null) {
    throw new Error('useDeeplinks must be used within a DeeplinksProvider');
  }

  return context;
};
